// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bB-E","importantInfo":"styles_importantInfo__2WyGQ"};